import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "content-section" }
const _hoisted_2 = {
  key: 0,
  class: "h2 mb-3 text-center"
}
const _hoisted_3 = {
  key: 1,
  class: "h2 mb-3 text-center"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, "Ändra ansökan", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "ms-1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "assets/icons/edit-icon.svg",
    alt: "Edit"
  })
], -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { style: {"border":"1px solid grey"} }, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_12 = { class: "row mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MortgageTopMenu = _resolveComponent("MortgageTopMenu")!
  const _component_ChangeRequest = _resolveComponent("ChangeRequest")!
  const _component_OfferCard = _resolveComponent("OfferCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (!_ctx.app.loanAmount && _ctx.isLoaded)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_2, " Du har ingen aktiv bolåneansökan. "))
        : (_openBlock(), _createElementBlock("h1", _hoisted_3, "Dina bolåneförslag")),
      _createVNode(_component_MortgageTopMenu, {
        showFoundProperty: 
          _ctx.app.purpose == 'PromissoryLetter' || _ctx.app.findProperty
        ,
        showMortgageCalculator: _ctx.app.showMortgageCalculationForActiveApp,
        active: "Låneförslag"
      }, null, 8, ["showFoundProperty", "showMortgageCalculator"])
    ]),
    (_ctx.app.loanAmount && _ctx.isLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "btn primary-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showchangeRequest = !_ctx.showchangeRequest))
              }, _hoisted_9)
            ])
          ]),
          _hoisted_10,
          (_ctx.showchangeRequest)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_ChangeRequest, {
                  loanAmount: _ctx.app.loanAmount ? _ctx.app.loanAmount : 0
                }, null, 8, ["loanAmount"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedOffers, (offer) => {
              return (_openBlock(), _createElementBlock("div", {
                key: offer.id,
                class: "mb-3"
              }, [
                _createVNode(_component_OfferCard, {
                  offer: offer,
                  app: _ctx.app,
                  onUpdate: _ctx.load
                }, null, 8, ["offer", "app", "onUpdate"])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}